export default "__VITE_ASSET__DVGLd8Wf__"